<template>
<!-- 校友会-选择讯息 -->
    <div class="poster-card-form">
        <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/poster-bg2.png" alt="">
        <div class="main">
            <!-- 头像 -->
            <div class="head-img">
                <img :src="item.headimgurl" alt="">
            </div>
            <!-- 内容 -->
            <div class="row">
                <p>我是：</p>
                <input type="text" v-model="form.text0" class="inp"  placeholder="请输入…" />
            </div>
            <div class="row">
                <p>我和新精英认识了（年）：</p>
                <input type="text" v-model="form.text1" class="inp" @keyup="inpChange()"  placeholder="请输入1-13正整数" />
            </div>
            <div class="row">
                <p>通过新精英我收获了：</p>
                <input type="text" v-model="form.text3" class="inp"  placeholder="请输入…" />
            </div>
            <div class="row">
                <p>在新精英我学过什么课程（多选）：</p>
                <div class="checkbox-row">
                    <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/checkbox-bg.png" alt="">
                    <div v-for="(item,index) in list" :key="index" @click="xjyCourseHandle(item)" :class="['checkbox',(index==list.length-1 || index==list.length-2)?'on':'']">
                        <img v-if="xjyCourse.includes(item)" src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/checkbox-on.png" alt="">
                        <img v-else src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/checkbox.png" alt="">
                        {{item}}
                    </div>
                </div>
            </div>
            <div class="row">
                <p>我2020年的闪亮时刻：</p>
                <textarea class="textarea" v-model="form.text4"  placeholder="只能输入50个字哦，请控制自己激动的小心情~"  ></textarea>
            </div>
            <div class="row">
                <p>我2021年的生涯实践计划：</p>
                <input type="text" v-model="form.text5" class="inp" placeholder="只能输入20个字哦，请控制自己激动的小心情~" />
            </div>
            <!-- btn -->
            <a class="btn" @click="createPoster()">
                <img  src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/poster-on.png" alt="">
            </a>
        </div>
        <!-- 海报生成的内容 -->
        <van-popup v-model="showPoster" class="poster-pop" :close-on-click-overlay="false"  >
            <img class="poster" :src="posterLink" alt="">
            <p class="text">长按保存图片，分享到朋友圈</p>
            <div class="btn-group">
                <img class="left-btn" @click="showPoster=false" src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/poster-left-btn.png" alt="">
                <img class="right-btn" @click="tabPoster()" src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/poster-right-btn.png" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
import { userInfo,createPoster,evenAdd } from '@/api/other'
import { shareCon } from "@/utils/wxconfig";
import { isMain } from "@/utils/tools";
export default {
    data(){
        return{
            item:{},
            form:{
                text0:'',
                text1:'',
                text2:'',
                text3:'',
                text4:'',
                text5:'',
                link:'',
                version:1
            },
            list:['双证班','测评课','实战班','优势课','版权课','高报课'],
            idx:0,
            // 海报显示
            showPoster:false,
            posterLink:'',
            xjyCourse:[]
        }
    },
    computed: {
      text4 () { return this.form.text4 },
      text5 () { return this.form.text5 },
    },
    watch:{
        text4(curVal, oldVal){
			if(curVal.length > 50) {
		      this.form.text4 = curVal.slice(0, 50);
		      this.$toast('最多只能输入50个字符。/(ㄒoㄒ)/~~');
		    }
        },
        text5(curVal, oldVal){
			if(curVal.length > 20) {
		      this.form.text5 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }
		}
    },
    methods:{
        // 我在新精英学习的课程
        xjyCourseHandle(item){
            if(this.xjyCourse.includes(item)){
                this.xjyCourse.splice(this.xjyCourse.indexOf(item),1)
            }else{
                this.xjyCourse.push(item);
            }
        },
        // 只能输入1-13并且是数字
        inpChange(){
            if(!/^[0-9]*$/g.test(this.form.text1)){
                this.form.text1 = null;
                this.$toast('只能输入数字！');
                return
            }

            if(this.form.text1<=0 || this.form.text1>13){
                this.$toast('只能输入1-13年！');
                this.form.text1 = null;
                return
            }
        },
        // 切换海报
        tabPoster(){
            this.randomVersion(true);
            this.createPoster();
        },
        // 生成海报
        createPoster(){
            let keys = Object.keys(this.form);
            if(keys){
                for(let i=0;i<keys.length;i++){
                    if(keys[i]=='link'){
                        this.form[keys[i]] = `https://open.xjy.cn/${isMain()?'main':'test'}/poster_card_index?from_user_id=${this.item.user_id}`;
                    }
                    if(keys[i]=='text2'){
                        this.form[keys[i]] = this.xjyCourse.join('、');
                    }
                    if(!this.form[keys[i]]){
                        console.log(keys[i])
                        this.$toast('请填写完整信息！');
                        return
                    }
                }
            }
            //调用加载中
            this.$emit('loadingHandle',true,"海报生成中...");
            createPoster({
                poster:'new_year_mark_2020',
                params:this.form
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail);
                    return
                }
                // 生成海报统计
                let obj ={
                    event:'new_year_mark_2020'  
                };
                if(this.$route.query.from_user_id){
                    obj['from_user_id'] = this.$route.query.from_user_id;
                }
                evenAdd(obj).then((data_)=>{
                    // this.$router.push('/ceping81_rank');
                });
                this.posterLink = data.image_url;
                this.showPoster = true;
            });

        },
        // 切换海报版本
        randomVersion(bool){
            this.$forceUpdate();
            if(this.idx==3){
                this.idx = 0;
            }else{
                this.idx+=1;
            }
            this.form.version = this.idx+1;
            // if(!bool){
            //     this.form.text4 = this.version[this.idx];
            // }
            
        },
        // 初始化获取数据
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            userInfo().then((data)=>{
                document.title = '我与新精英的“ 2020 ”';
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail);
                    return
                }
                this.item = data;
                shareCon("index", this);
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
    .poster-pop{
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: transparent;
        overflow: auto;
        img.poster{
            width: 538px;
            background: transparent;
            border-radius: 20px;
            margin-bottom: 20px;
        }
        .text{
            font-size: 24px;
            color: #ffffff;
            font-weight: bold;
            margin-bottom: 25px;
            letter-spacing: 5px;
        }
        .btn-group{
            display: flex;
            justify-content: space-between;
            .left-btn{
                width: 273px;
                height: 87px;
                &:first-of-type{
                    margin-right: 16px;
                }
            }
            .right-btn{
                width: 273px;
                height: 87px;
            }
        }
    }
</style>
<style lang="scss" scoped>
input{
    -webkit-appearance: none;
}
.poster-card-form{
    .animated{
        animation-duration:2s;
    }
    .bg{
        width: 100%;
    }
    .main{
        margin-top: -1420px;
        padding: 0 30px 80px;
        .head-img{
            text-align: center;
            img{
                width: 160px;
                height: 160px;
                border: 3px solid #530F10;
                border-radius: 80px;
                background: #FFFFFF;
            }
        }
        .row{
            margin-bottom: 40px;
            &:last-of-type{
                margin-bottom: 50px;
            }
            p{
                font-size: 32px;
                font-weight: 500;
                color: #530F10;
                line-height: 1;
                margin-bottom: 10px;
            }
            .inp{
                width: 690px;
                border: none;
                height: 80px;
                color: #530F10;
                font-size: 28px;
                font-weight: 400;
                padding: 0 30px;
                line-height: 80px;
                background-image:url('https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/inp-bg.png');
                background-repeat:no-repeat;
                background-size: 100% 100%;
                box-sizing: border-box;
            }
            .textarea{
                color: #530F10;
                font-size: 28px;
                font-weight: 400;
                padding: 20px 30px;
                box-sizing: border-box;
                width: 690px;
                border: none;
                height: 110px;
                background-image:url('https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/trext-bg.png');
                background-repeat:no-repeat;
                background-size: 100% 100%;
            }
            .checkbox-row{
                display: flex;
                flex-wrap: wrap;
                padding: 25px 0;
                position: relative;
                background: transparent;
                .bg{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                }
                .checkbox{
                    text-align: center;
                    width: 50%;
                    font-size: 28px;
                    font-weight: 400;
                    color: #530F10;
                    margin-bottom: 30px;
                    background: transparent;
                    position: relative;
                    z-index: 2;
                    img{
                        width: 30px;
                        height: 30px;
                        margin-right: 10px;
                    }
                }
                .checkbox.on{
                    margin-bottom: 0;
                }
            }
        }
        .btn{
            display: block;
            text-align: center;
            margin-bottom: 38px;
            img{
                width: 483px;
                height: 104px;
                animation: scaleDraw 2s  infinite;
            }
        }
    }
    
}
input::-webkit-input-placeholder { 
/* WebKit browsers */ 
  color: rgba(92, 36, 37, 0.6); 
} 
input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
  color: rgba(92, 36, 37, 0.6); 
} 
input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
  color: rgba(92, 36, 37, 0.6); 
} 
input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
  color: rgba(92, 36, 37, 0.6); 
}


textarea::-webkit-input-placeholder { 
/* WebKit browsers */ 
  color: rgba(92, 36, 37, 0.6); 
} 
textarea:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
  color: rgba(92, 36, 37, 0.6); 
} 
textarea::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
  color: rgba(92, 36, 37, 0.6); 
} 
textarea:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
  color: rgba(92, 36, 37, 0.6); 
}
</style>